// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.dispatch-container .ant-table-cell {
  line-height: 1 !important;
  padding: 0.25rem 0.5rem !important;
  border-right: 1px solid rgba(211, 211, 211, 0.7607843137);
}
.dispatch-container .ant-picker-range {
  padding-left: 5.625rem;
}
.dispatch-container .notes-list {
  padding: 0.25rem;
  border: 1px solid gray;
  height: 18.75rem;
}
.dispatch-container .notes-list-item {
  border: 1px solid lightgray;
  margin-bottom: 0.25rem;
  background-color: rgba(219, 162, 56, 0.46);
  color: black;
  padding: 0.125rem 0.25rem;
  font-size: 0.825rem;
}
.dispatch-container .notes-list-item.selected {
  color: #ffffff !important;
  border: none;
  background: rgb(219, 162, 56);
}
.dispatch-container .notes-detail {
  margin-left: 0.5rem;
  padding: 0.5rem;
  border: 1px solid gray;
}
.dispatch-container .notes-value {
  color: var(--text-color-primary);
  font-weight: bold;
  font-size: 1rem;
}
.dispatch-container .notes-header {
  font-size: 1.5rem;
  font-weight: bold;
}

.receiver-modal .ant-modal-body {
  height: max-content !important;
}

.viewer-modal .ant-modal-content .ant-modal-body {
  overflow-y: auto;
}

.viewer-modal .react-pdf__Page__canvas {
  width: 50rem !important;
  height: 68.75rem !important;
}

/* ===== Dispatch — Filter Section (page-specific field widths) =====
   Shared chrome (.filter-toolbar, .filter-layout, .filter-modalities, .btn-*)
   comes from the globally-imported custom-app.css. */
.disp-filters-row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0.5rem;
  margin-top: 0.75rem;
}

.disp-field {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.disp-field--name {
  width: 10rem;
}

.disp-field--id {
  width: 7.5rem;
}

.disp-field--acc {
  width: 7.5rem;
}

.disp-field--ref {
  width: 10rem;
}

.disp-field--body {
  width: 9.375rem;
}

.disp-field--date {
  width: 16rem;
}

.disp-filters-row .ant-input,
.disp-filters-row .ant-picker,
.disp-filters-row .ant-select {
  width: 100% !important;
}

/* Clear/Search buttons sit inline right beside the date filter (bottom-aligned),
   replacing the old full-width toolbar row to save vertical space. */
.disp-actions {
  display: flex;
  align-items: flex-end;
  gap: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./pages/Dispatch/dispatch.scss"],"names":[],"mappings":"AAAA,gBAAgB;AACd;EACE,yBAAA;EACA,kCAAA;EACA,yDAAA;AACJ;AAEE;EACE,sBAAA;AAAJ;AAGE;EACE,gBAAA;EACA,sBAAA;EACA,gBAAA;AADJ;AAIE;EACE,2BAAA;EACA,sBAAA;EACA,0CAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;AAFJ;AAKE;EACE,yBAAA;EACA,YAAA;EACA,6BAAA;AAHJ;AAME;EACE,mBAAA;EACA,eAAA;EACA,sBAAA;AAJJ;AASE;EACE,gCAAA;EACA,iBAAA;EACA,eAAA;AAPJ;AAUE;EACE,iBAAA;EACA,iBAAA;AARJ;;AAYA;EAEE,8BAAA;AAVF;;AAaA;EACE,gBAAA;AAVF;;AAaA;EACE,uBAAA;EACA,2BAAA;AAVF;;AAaA;;qDAAA;AAGA;EACE,aAAA;EACA,eAAA;EACA,qBAAA;EACA,WAAA;EACA,mBAAA;AAVF;;AAaA;EACE,aAAA;EACA,sBAAA;EACA,YAAA;AAVF;;AAaA;EAAoB,YAAA;AATpB;;AAUA;EAAoB,aAAA;AANpB;;AAOA;EAAoB,aAAA;AAHpB;;AAIA;EAAoB,YAAA;AAApB;;AACA;EAAoB,eAAA;AAGpB;;AAFA;EAAoB,YAAA;AAMpB;;AAJA;;;EAGE,sBAAA;AAOF;;AAJA;qEAAA;AAEA;EACE,aAAA;EACA,qBAAA;EACA,WAAA;AAOF","sourcesContent":[".dispatch-container {\r\n  .ant-table-cell {\r\n    line-height: 1 !important;\r\n    padding: 0.25rem 0.5rem !important;\r\n    border-right: 1px solid #d3d3d3c2;\r\n  }\r\n\r\n  .ant-picker-range {\r\n    padding-left: 5.625rem;\r\n  }\r\n\r\n  .notes-list {\r\n    padding: 0.25rem;\r\n    border: 1px solid gray;\r\n    height: 18.75rem\r\n  }\r\n\r\n  .notes-list-item {\r\n    border: 1px solid lightgray;\r\n    margin-bottom: 0.25rem;\r\n    background-color: rgb(219 162 56 / 46%);\r\n    color: black;\r\n    padding: 0.125rem 0.25rem;\r\n    font-size: 0.825rem;\r\n  }\r\n\r\n  .notes-list-item.selected {\r\n    color: #ffffff !important;\r\n    border: none;\r\n    background: rgb(219 162 56);\r\n  }\r\n\r\n  .notes-detail {\r\n    margin-left: 0.5rem;\r\n    padding: 0.5rem;\r\n    border: 1px solid gray;\r\n  }\r\n\r\n  .notes-label {}\r\n\r\n  .notes-value {\r\n    color: var(--text-color-primary);\r\n    font-weight: bold;\r\n    font-size: 1rem;\r\n  }\r\n\r\n  .notes-header {\r\n    font-size: 1.5rem;\r\n    font-weight: bold;\r\n  }\r\n}\r\n\r\n.receiver-modal .ant-modal-body {\r\n  // height: 75vh;\r\n  height: max-content !important;\r\n}\r\n\r\n.viewer-modal .ant-modal-content .ant-modal-body {\r\n  overflow-y: auto;\r\n}\r\n\r\n.viewer-modal .react-pdf__Page__canvas {\r\n  width: 50rem !important;\r\n  height: 68.75rem !important;\r\n}\r\n\r\n/* ===== Dispatch — Filter Section (page-specific field widths) =====\r\n   Shared chrome (.filter-toolbar, .filter-layout, .filter-modalities, .btn-*)\r\n   comes from the globally-imported custom-app.css. */\r\n.disp-filters-row {\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: flex-end;\r\n  gap: 0.5rem;\r\n  margin-top: 0.75rem;\r\n}\r\n\r\n.disp-field {\r\n  display: flex;\r\n  flex-direction: column;\r\n  min-width: 0;\r\n}\r\n\r\n.disp-field--name { width: 10rem; }\r\n.disp-field--id   { width: 7.5rem; }\r\n.disp-field--acc  { width: 7.5rem; }\r\n.disp-field--ref  { width: 10rem; }\r\n.disp-field--body { width: 9.375rem; }\r\n.disp-field--date { width: 16rem; }\r\n\r\n.disp-filters-row .ant-input,\r\n.disp-filters-row .ant-picker,\r\n.disp-filters-row .ant-select {\r\n  width: 100% !important;\r\n}\r\n\r\n/* Clear/Search buttons sit inline right beside the date filter (bottom-aligned),\r\n   replacing the old full-width toolbar row to save vertical space. */\r\n.disp-actions {\r\n  display: flex;\r\n  align-items: flex-end;\r\n  gap: 0.5rem;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
